import React, { useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const [hasWaited, setHasWaited] = useState(false);

  // Add a small delay to ensure auth state is properly set
  useEffect(() => {
    const timer = setTimeout(() => {
      setHasWaited(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  if (loading || !hasWaited) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
